import {ProjectMinRes} from '../tracker/project-tracker';
import {ContactPersonDetailRes} from '../user.contract';
import {formatFromMinutes, minToHours} from './general-task-utils';
import {TaskEffortCreateReq, TaskEffortRes} from './task-effort';
import {TaskReferenceRes, TaskReferenceUpdateReq} from './task-reference.contract';

export class BaseTaskMinRes {
    id!: string;
    taskId!: string;
    category!: string;
    currentStart!: Date;
    currentEnd!: Date;
    currentPlanned!: number;
    name?: string;
    description?: string;
    project?: ProjectMinRes;
    projectId?: number;
}

export class BaseTaskRes {
    id!: string;
    taskId!: string;
    category!: string;
    contact: ContactPersonDetailRes[] = [];
    risks: string[] = [];
    clarifications: string[] = [];
    originalStart!: Date;
    originalEnd!: Date;
    originalEstimated!: number;
    currentEstimated!: number;
    currentStart!: Date;
    currentEnd!: Date;
    currentPlanned!: number;
    taskType!: string;
    name?: string;
    description?: string;
    recentAppointmentsCnt!: number;
    project?: ProjectMinRes;
    projectId?: number;
    contacts: ContactPersonDetailRes[] = []
    references: TaskReferenceRes[] = []

    get currentStartDate(): Date {
        return new Date(this.currentStart);
    }

    set currentStartDate(date: Date) {
        this.currentEnd = date
    }

    get currentEndDate(): Date {
        return new Date(this.currentEnd)
    }

    set currentEndDate(date: Date) {
        this.currentEnd = date
    }


    efforts: TaskEffortRes[] = [];

    get customerFacingId(): string {
        if (this.taskId !== undefined) return this.taskId;
        return this.id.toString()
    }

    get estimatedEffortSum() {
        let effort_in_min = this.efforts.reduce((a, b) => a + (b.estimatedDurationInMin ?? 0), 0)
        let formatted = formatFromMinutes(effort_in_min)
        return {formatted: formatted, hours: minToHours(effort_in_min), rawMinutes: effort_in_min}
    }

    get actualEffortSum() {
        let effort_in_min = this.efforts.reduce((a, b) => a + (b.actualDurationInMin ?? 0), 0)
        let formatted = formatFromMinutes(effort_in_min)
        return {formatted: formatted, hours: minToHours(effort_in_min), rawMinutes: effort_in_min}
    }

}

export class BaseTaskCreateReq {
    name!: string
    description!: string
    taskId?: string
    contactsIds:number[]=[]
    risks:string[]=[]
    clarification:string[]=[]
    projectId?:number
    start!:string
    end!:string
    estimated!:number
    maxBudgets?:number
    references:TaskReferenceUpdateReq[] = []
    constructor(value: Partial<BaseTaskCreateReq>) {
        Object.assign(this, value)
    }
}

export class BaseTaskUpdateReq{
    id!:string;
    name!:string
    newStart?:string|null
    newEnd?:string|null
    newEstimated?:string
    taskId!:string;
    category!:string;
    maxBudget!:number;
    projectId!:number;
    efforts:TaskEffortCreateReq[] = [];
    references:TaskReferenceUpdateReq[] = []


    constructor(value: Partial<BaseTaskUpdateReq>) {
        Object.assign(this, value)
        console.log(this)
    }
}
